import Vue from 'vue';
import VueRouter from 'vue-router';
import { findBySystemInfo } from "../api/loginMange";
import fr from "element-ui/src/locale/lang/fr";
import { Message } from "element-ui";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: () => import('@/views/Layout/Layout'),
    redirect: '/selectPage',
    children: [
      {
        path: '/sys/company',
        name: 'sysCompany',
        component: () => import('@/views/system/SystemManage'),
        meta: { title: '系统管理' },
      },
      /* 用户管理 */
      {
        path: '/sys/user',
        name: 'sysUser',
        component: () => import('@/views/user/UserManage'),
        meta: { title: '用户管理' },
      },
      {
        path: '/sys/addUser',
        name: 'sysAddUser',
        component: () => import('@/views/user/AddUser'),
        meta: { title: '新增用户' },
      },
      {
        path: '/sys/user/permissionConfig',
        name: 'sermissionConfig',
        component: () => import('@/views/user/PermissionConfig'),
        meta: { title: '权限配置' }
      },
      {
        path: '/sys/user/custompermission',
        name: 'sustomPermission',
        component: () => import('@/views/user/CustomPermission'),
        meta: { title: '自定义权限' }
      },
      {
        path: '/sys/editUser',
        name: 'sysEditUser',
        component: () => import('@/views/user/EditUser'),
        meta: { title: '编辑用户' },
      },
      /* 角色管理 */
      {
        path: '/sys/role',
        name: 'sysRole',
        component: () => import('@/views/role/RoleManage'),
        meta: { title: '角色管理', keepalive: true  }
      },
      {
        path: '/userMange/userAssignRole',
        name: 'userMangeAssignRole',
        component: () => import('@/views/user/UserAssignRole'),
        meta: { title: '角色分配' },
      },
      {
        path: '/sys/role/addRole',
        name: 'sysAddRole',
        component: () => import('@/views/role/AddRole'),
        meta: { title: '角色管理' }
      },
      {
        path: '/roleManage/assignmentRole',
        name: 'assignmentRole',
        component: () => import('@/views/role/AssignmentRole'),
        meta: { title: '角色管理' }
      },
      {
        path: '/rolemange/rolejurisdiction',
        name: 'roleJurisdiction',
        component: () => import('@/views/role/RoleJurisdiction')
      },
      /* 菜单管理 */
      {
        path: '/sys/menu',
        name: 'sysMenu',
        component: () => import('@/views/menu/MenuManage'),
        meta: { title: '菜单管理', keepalive: true }
      },
      {
        path: '/sys/menu/addMenu',
        name: 'sysAddMenu',
        component: () => import('@/views/menu/AddMenu'),
        meta: { title: '菜单管理' }
      },
      /* 部门管理 */
      {
        path: '/sys/group',
        name: 'sysGroup',
        component: () => import('@/views/depart/DepartManage'),
        meta: { title: '部门管理', keepalive: true  }
      },
      {
        path: '/sys/group/addDepart',
        name: 'sysAddDepart',
        component: () => import('@/views/depart/AddDepart'),
        meta: { title: '部门管理' }
      },
      /* 字典管理 */
      {
        path: '/sys/dict',
        name: 'sysDict',
        component: () => import('@/views/dict/dictMange'),
        meta: { title: '字典管理' }
      },
      /* 岗位管理 */
      {
        path: '/sys/position',
        name: 'sysPosition',
        component: () => import('@/views/post/PostManage'),
        meta: { title: '岗位管理', keepalive: true }
      },
      {
        path: '/sys/position/addPosition',
        name: 'sysAddPosition',
        component: () => import('@/views/post/AddPosition'),
        meta: { title: '岗位管理' }
      },
      /* 组织架构 */
      {
        path: '/sys/organizational',
        name: 'sysOrganizational',
        component: () => import('@/views/organizational/index'),
        meta: { title: '权限配置' }
      },
      {
        path: '/sys/organizational/startconfigure',
        name: 'sysStartConfigure',
        component: () => import('@/views/organizational/startConfig'),
        meta: { title: '权限配置' }
      },
      {
        path: '/sys/organizational/addUsers',
        name: 'sysOrgAddUsers',
        component: () => import('@/views/organizational/AddUsers'),
        meta: { title: '新增用户' },
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login'),
    meta: {
      title: '登录',
    }
  },
  {
    path: '/selectPage',
    name: 'selectPage',
    component: () => import('@/views/system/selectPage'),
    meta: {
      title: '系统选择',
    }
  },
  {
    path: '*',
    name: 'notFound',
    component: () => import('@/views/404'),
    meta: {
      title: '404',
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes,
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'CRM权限管理系统';
  const token = window.sessionStorage.getItem('userInfo') ? JSON.parse(window.sessionStorage.getItem('userInfo')).token : ''

  if (to.path !== '/login') {
    // 因为没有user,所以
    if (token) {
      next()
    } else {
      // 没有登录，跳转到登录页面
      next('/login')
    }
  } else {
    next()
  }
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

export default router;
